import { render, staticRenderFns } from "./polyVaccin.vue?vue&type=template&id=3e0fab2a"
import script from "./polyVaccin.vue?vue&type=script&lang=js"
export * from "./polyVaccin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports